import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AuthService} from "../../../core/service/auth.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css']
})
export class DeleteAccountComponent extends CoreComponent {

  formGroup: FormGroup | undefined;

  constructor(
    protected settingService: SettingsService,
    protected router: Router,
    protected registrationApiService: RegistrationApiService,
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected messageService: AppMessageService,
    protected userApiService: UserApiService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('Account löschen', ' ');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.buildFormGroup();
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      confirmText: ['', Validators.required],
      password: ['', Validators.required],
    })
  }


  handleDeactivateAccount() {
    if (this.formGroup) {

      const password = this.formGroup.get('password')?.value;

      this.userApiService.deactivate(password).subscribe(res => {
        this.authService.logout();
        this.router.navigate(['/login']);
      }, error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
      })


    }
  }

  handleCheckText() {
    const confirmText = this.formGroup?.get('confirmText')?.value;

    if (confirmText != 'lösche mein Konto') {
      this.formGroup?.get('confirmText')?.setErrors({noMatch: 'Text stimmt nicht überein'});
    }

  }


}
